<template>
  <v-container id="master-kecamatan" fluid tag="section" class="cyber-container">
    <v-row>
      <v-col cols="12">
        <base-material-card
          color="#018C74"
          icon="mdi-map-marker-radius"
          class="glass-card"
        >
          <template v-slot:heading>
            <div class="display-2 font-weight-black cyber-title">
              DATA WILAYAH KECAMATAN
            </div>
            <div class="subtitle-1 font-weight-light secondary-text">
              Sistem Manajemen Geografis & Administrasi
            </div>
          </template>

          <v-card-text class="mt-4">
            <v-row class="mb-6 align-center">
              <v-col cols="12" md="6">
                <v-btn class="cyber-btn-add" @click="openDialog()">
                  <v-icon left>mdi-plus-circle-outline</v-icon>
                  TAMBAH KECAMATAN BARU
                </v-btn>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify-scan"
                  label="Cari Data Wilayah..."
                  single-line
                  hide-details
                  flat
                  solo-inverted
                  class="cyber-search"
                />
              </v-col>
            </v-row>

            <v-data-table
              :headers="headers"
              :items="kecamatanList"
              :search="search"
              :loading="loading"
              class="transparent-table"
            >
              <template v-slot:item.id="{ item }">
                <span class="cyber-id">#{{ item.id }}</span>
              </template>

              <template v-slot:item.foto="{ item }">
                <div class="photo-frame">
                  <v-img
                    :src="renderImage(item.foto)"
                    aspect-ratio="1.7"
                    width="100"
                    height="60"
                    cover
                    class="rounded-sm cyber-border"
                  >
                    <template v-slot:placeholder>
                      <v-row class="fill-height ma-0" align="center" justify="center">
                        <v-icon color="#018C74">mdi-satellite-variant</v-icon>
                      </v-row>
                    </template>
                  </v-img>
                </div>
              </template>

              <template v-slot:item.nama_kecamatan="{ item }">
                <span class="text-uppercase font-weight-bold white--text">{{
                  item.nama_kecamatan
                }}</span>
              </template>

              <template v-slot:item.actions="{ item }">
                <v-btn icon color="#018C74" @click="openDialog(item)" class="mx-1">
                  <v-icon small>mdi-pencil-box-outline</v-icon>
                </v-btn>
                <v-btn icon color="#ff5252" @click="deleteItem(item)" class="mx-1">
                  <v-icon small>mdi-trash-can-outline</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </base-material-card>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog" max-width="600px" persistent overlay-opacity="0.9">
      <v-card class="cyber-dialog">
        <v-card-title class="dialog-header">
          <v-icon left color="#CFA22D">mdi-map-check</v-icon>
          <span class="font-weight-bold white--text">{{ formTitle }}</span>
          <v-spacer />
          <v-btn icon @click="close" small ><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>

        <v-card-text class="pt-8 px-6">
          <v-text-field
            v-model="editedItem.nama_kecamatan"
            label="Nama Kecamatan"
            outlined
            color="#018C74"
            class="cyber-input"
          />
          <v-textarea
            v-model="editedItem.deskripsi"
            label="Deskripsi Wilayah"
            outlined
            color="#018C74"
            rows="3"
            class="cyber-input"
          />

          <v-file-input
            v-model="imageFile"
            label="Unggah Citra Wilayah (Foto)"
            accept="image/*"
            prepend-icon=""
            prepend-inner-icon="mdi-camera-outline"
            outlined
            color="#018C74"
            @change="previewImage"
            class="cyber-input"
          />

          <v-expand-transition>
            <div v-if="imageUrl" class="d-flex justify-center mb-4">
              <div class="preview-container">
                <div class="scan-line"></div>
                <v-img
                  :src="imageUrl"
                  max-height="200"
                  contain
                  class="rounded border-glow"
                />
              </div>
            </div>
          </v-expand-transition>
        </v-card-text>

        <v-card-actions class="pa-6">
          <v-btn text @click="close" class="white--text opacity-7">BATAL</v-btn>
          <v-spacer></v-spacer>
          <v-btn class="cyber-btn-save" :loading="loading" @click="save">
            SIMPAN DATA
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from "axios";
const BASE_URL = "https://berkah.bondowosokab.go.id:5500";
const API_URL = `${BASE_URL}/kecamatan`;

export default {
  data: () => ({
    search: "",
    loading: false,
    dialog: false,
    kecamatanList: [],
    imageFile: null,
    imageUrl: null,
    headers: [
      { text: "ID", value: "id", width: "80px" },
      { text: "CITRA SATELIT", value: "foto", width: "130px", sortable: false },
      { text: "NAMA KECAMATAN", value: "nama_kecamatan" },
      { text: "DESKRIPSI", value: "deskripsi" },
      { text: "AKSI", value: "actions", sortable: false, align: "end" },
    ],
    editedIndex: -1,
    editedItem: { id: null, nama_kecamatan: "", deskripsi: "", foto: "" },
    defaultItem: { id: null, nama_kecamatan: "", deskripsi: "", foto: "" },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "PENDAFTARAN WILAYAH" : "PEMBARUAN DATA WILAYAH";
    },
  },

  mounted() {
    this.fetchData();
  },

  methods: {
    renderImage(filename) {
      if (!filename) return null;
      return encodeURI(`${BASE_URL}/uploads/${filename}`);
    },

    async fetchData() {
      this.loading = true;
      try {
        const res = await axios.get(API_URL);
        if (res.data && res.data.response && Array.isArray(res.data.response.data)) {
          this.kecamatanList = res.data.response.data;
        } else {
          this.kecamatanList = [];
        }
      } catch (e) {
        console.error("Gagal load data:", e);
        this.kecamatanList = [];
      } finally {
        this.loading = false;
      }
    },

    previewImage() {
      if (this.imageFile) {
        this.imageUrl = URL.createObjectURL(this.imageFile);
      } else {
        this.imageUrl =
          this.editedIndex > -1 ? this.renderImage(this.editedItem.foto) : null;
      }
    },

    openDialog(item) {
      this.editedIndex = item ? this.kecamatanList.indexOf(item) : -1;
      this.editedItem = item
        ? Object.assign({}, item)
        : Object.assign({}, this.defaultItem);
      this.imageUrl = item ? this.renderImage(item.foto) : null;
      this.imageFile = null;
      this.dialog = true;
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.imageFile = null;
        this.imageUrl = null;
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    async save() {
      if (!this.editedItem.nama_kecamatan) return alert("Nama Kecamatan wajib diisi");
      this.loading = true;
      try {
        const formData = new FormData();
        formData.append("nama_kecamatan", this.editedItem.nama_kecamatan);
        formData.append("deskripsi", this.editedItem.deskripsi || "");
        if (this.imageFile) formData.append("foto", this.imageFile);

        if (this.editedIndex > -1) {
          await axios.put(`${API_URL}/${this.editedItem.id}`, formData);
        } else {
          await axios.post(API_URL, formData);
        }
        this.fetchData();
        this.close();
      } catch (e) {
        alert("Gagal menyimpan data");
      } finally {
        this.loading = false;
      }
    },

    async deleteItem(item) {
      if (confirm(`Hapus data Kecamatan ${item.nama_kecamatan}?`)) {
        try {
          await axios.delete(`${API_URL}/${item.id}`);
          this.fetchData();
        } catch (e) {
          alert("Gagal menghapus data");
        }
      }
    },
  },
};
</script>

<style scoped>
.cyber-container {
  background: transparent;
}

.cyber-title {
  letter-spacing: 3px !important;
  text-shadow: 0 0 10px rgba(1, 140, 116, 0.4);
  color: white !important;
}

.glass-card {
  background: rgba(0, 26, 22, 0.8) !important;
  backdrop-filter: blur(15px);
  border: 1px solid rgba(1, 140, 116, 0.3) !important;
}

.transparent-table {
  background: transparent !important;
}
.transparent-table >>> th {
  color: #cfa22d !important;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  border-bottom: 2px solid #018c74 !important;
}
.cyber-id {
  font-family: "Courier New", monospace;
  color: #cfa22d;
  font-weight: bold;
}

.cyber-btn-add {
  background: linear-gradient(45deg, #018c74, #004d40) !important;
  color: white !important;
  border: 1px solid #cfa22d !important;
  font-weight: 900;
  box-shadow: 0 0 15px rgba(1, 140, 116, 0.3) !important;
}

.cyber-btn-save {
  background-color: #cfa22d !important;
  color: #002616 !important;
  font-weight: 900 !important;
}

.photo-frame {
  padding: 3px;
  border: 1px solid rgba(207, 162, 45, 0.3);
  display: inline-block;
  background: rgba(255, 255, 255, 0.05);
}

.preview-container {
  position: relative;
  border: 2px solid #018c74;
  padding: 5px;
  background: #000;
  overflow: hidden;
}

.scan-line {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background: #cfa22d;
  box-shadow: 0 0 8px #cfa22d;
  animation: scan 3s linear infinite;
  z-index: 2;
}

@keyframes scan {
  0% {
    top: 0;
  }
  100% {
    top: 100%;
  }
}

.cyber-dialog {
  background: rgba(0, 20, 18, 0.95) !important;
  border: 1px solid #018c74 !important;
}
.dialog-header {
  border-bottom: 1px solid rgba(1, 140, 116, 0.3);
  background: rgba(1, 140, 116, 0.1);
}

.cyber-page,
.cyber-container,
.cyber-portal {
  background: transparent !important;
}

.cyber-title,
.cyber-text,
.cyber-id,
.cyber-desc,
.cyber-item-text {
  color: #1c2b28 !important;
  text-shadow: none !important;
}

.secondary-text {
  color: #018c74 !important;
  text-shadow: none !important;
}

.glass-card,
.cyber-card,
.cyber-dialog,
.cyber-dialog-card,
.cyber-modal,
.cyber-map-container,
.cyber-mapping-container,
.cyber-news-container,
.cyber-moments,
.cyber-carousel,
.cyber-agenda,
.cyber-sosmed-header,
.cyber-map-box,
.cyber-map {
  background: #ffffff !important;
  border: 1px solid #eef1f0 !important;
  backdrop-filter: none !important;
  color: #1c2b28 !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04) !important;
}

.dialog-header,
.dialog-header-gradient {
  background: #f4f7f6 !important;
  color: #1c2b28 !important;
  border-bottom: 1px solid #eef1f0 !important;
}

.dialog-header .white--text,
.dialog-header-gradient .white--text,
.cyber-dialog .white--text,
.cyber-dialog-card .white--text {
  color: #1c2b28 !important;
}

.dialog-neon-line,
.neon-line {
  background: linear-gradient(90deg, #018c74, #cfa22d, #018c74) !important;
}

.transparent-table,
.cyber-table,
.transparent-tabs {
  background: #ffffff !important;
  color: #1c2b28 !important;
}

.transparent-table >>> th,
.cyber-table >>> th {
  background: #f4f7f6 !important;
  color: #018c74 !important;
  font-weight: 800;
  border-bottom: 2px solid #018c74 !important;
}

.transparent-table >>> td,
.cyber-table >>> td {
  color: #1c2b28 !important;
  border-bottom: 1px solid #eef1f0 !important;
}

.transparent-table >>> .v-data-table__empty-wrapper,
.cyber-table >>> .v-data-table__empty-wrapper {
  color: #9aa6a3 !important;
}

.cyber-input,
.cyber-field,
.cyber-search,
.cyber-search-field,
.cyber-search-bar,
.cyber-input-mini,
.cyber-input-dense,
.cyber-input-highlight,
.cyber-input-coord,
.cyber-coord-field,
.cyber-select-dense,
.cyber-file-input,
.cyber-datepicker {
  color: #1c2b28 !important;
}

.cyber-input >>> .v-input__control,
.cyber-field >>> .v-input__control,
.cyber-search >>> .v-input__control,
.cyber-search-field >>> .v-input__control,
.cyber-search-bar >>> .v-input__control,
.cyber-input-mini >>> .v-input__control,
.cyber-input-dense >>> .v-input__control,
.cyber-input-highlight >>> .v-input__control,
.cyber-input-coord >>> .v-input__control,
.cyber-coord-field >>> .v-input__control,
.cyber-select-dense >>> .v-input__control,
.cyber-file-input >>> .v-input__control,
.cyber-datepicker >>> .v-input__control {
  background: #ffffff !important;
  border-radius: 10px;
}

.cyber-input >>> input,
.cyber-field >>> input,
.cyber-search >>> input,
.cyber-search-field >>> input,
.cyber-search-bar >>> input,
.cyber-input-mini >>> input,
.cyber-input-dense >>> input,
.cyber-input-coord >>> input,
.cyber-coord-field >>> input,
.cyber-datepicker >>> input,
.cyber-input >>> .v-label,
.cyber-field >>> .v-label,
.cyber-search >>> .v-label,
.cyber-search-field >>> .v-label,
.cyber-search-bar >>> .v-label,
.cyber-select-dense >>> .v-label,
.cyber-datepicker >>> .v-label {
  color: #1c2b28 !important;
}

.cyber-btn-add,
.cyber-add-btn,
.cyber-add-sosmed-btn {
  background: linear-gradient(135deg, #018c74 0%, #02b395 100%) !important;
  color: #ffffff !important;
  font-weight: 700;
  border: none !important;
  box-shadow: 0 8px 20px rgba(1, 140, 116, 0.25) !important;
}

.cyber-btn-save,
.cyber-save-btn {
  background: #018c74 !important;
  color: #ffffff !important;
  font-weight: 700 !important;
  box-shadow: 0 8px 20px rgba(1, 140, 116, 0.25) !important;
}

.icon-scan-box,
.icon-scan-frame,
.preview-container,
.preview-hex-frame,
.preview-mini-frame,
.preview-scanner {
  background: #f4f7f6 !important;
  border: 1px solid #eef1f0 !important;
}

.preview-tag {
  background: #eaf6f3 !important;
  color: #018c74 !important;
  border: 1px solid rgba(1, 140, 116, 0.3) !important;
}

.scan-overlay {
  display: none !important;
}

.shadow-glow,
.shadow-glow-gold,
.shadow-glow-teal {
  box-shadow: 0 6px 16px rgba(1, 140, 116, 0.15) !important;
}

.action-glow.edit-btn,
.action-glow.delete-btn {
  background: transparent !important;
}


.v-data-table >>> .white--text {
  color: #1c2b28 !important;
}
.plain-description {
  color: #4a5a57 !important;
}

</style>
